<template>
  <div>
    <el-dialog
      v-if="showForm"
      :visible.sync="showForm"
      width="80%"
      custom-class="more-info-dialog"
      :title="$t('resultLogButton.result')"
      center
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="more-info__inner">
        <div class="mono-text info-dialog">{{ schedulePacketsInfo }}</div>
      </div>
      <div class="bottom-buttons">
        <el-button @click="downloadClick" icon="el-icon-download">
          {{ $t("navigation.commonTree.saveInFile") }}
        </el-button>
      </div>
    </el-dialog>
    <template-form></template-form>
    <template-task-form></template-task-form>
    <div v-if="cronTemplates && cronTemplates.length >= 0">
      <div class="header cron">
        <div>
          <div v-if="!!selectedTemplate" class="header-name">
            {{ $t("templates.selected") + ":" + " " + selectedTemplate.name }}
          </div>
        </div>

        <div class="header-buttons">
          <el-button @click="createTemplateClick"
            >{{ $t("templates.addTemplate") }}
          </el-button>
          <el-button @click="copyTemplate" :disabled="!selectedTemplate"
            >{{ $t("templates.copyTemplate") }}
          </el-button>
          <el-dropdown>
            <el-button :disabled="!selectedTemplate"
              >{{ $t("packets.edit")
              }}<i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="updTemplate">{{
                $t("templates.editTemplateName")
              }}</el-dropdown-item>
              <el-dropdown-item @click.native="createTasksClick">{{
                $t("templates.editTemplateTasks")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown>
            <el-button :disabled="!selectedTemplate"
              >{{ $t("packets.schedule")
              }}<i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="activateSchedule">{{
                $t("templates.activateSchedule")
              }}</el-dropdown-item>
              <el-dropdown-item @click.native="forbidSchedule">{{
                $t("templates.forbidSchedule")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button :disabled="!selectedTemplate" @click="deleteTemplate"
            >{{ $t("templates.deleteTemplate") }}
          </el-button>
        </div>
      </div>
      <div class="main-content list">
        <div
          v-for="(template, index) in cronTemplates"
          :key="index"
          @click="templateSelected(template)"
          class="list-item main-list-element"
          :class="templateClassArray[index]"
        >
          <span
            class="main-list-element-label"
            :class="{ 'not-saved': template.notSync }"
          >
            <span class="name">{{ template.name }}</span>
            <!-- &horbar; {{ template.nameSection }} -->
            <!-- -- {{template.dateSave}} -->
            <span v-if="template.notSync" style="float: right"
              >{{ $t("templates.packageWithPreviousVersion") }}
            </span>
          </span>
          <div
            v-for="(task, index) in template.tasks"
            :key="index"
            class="main-list-task-element main-sublist-item"
          >
            {{ task.caption }} &horbar; {{ task.params }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateForm from "./TemplateForm";
import TemplateTaskForm from "./TemplateTaskForm";
import markUnsavedMixin from "./markUnsavedMixin";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      templateClassArray: [],
      dataReloadingFlag: false,
      schedulePacketsInfo: null,
      showForm: false,
    };
  },
  methods: {
    templateSelected(template) {
      //   this.selectedTemplate = template;
      this.$store.commit("setTemplate", template);
    },
    createTemplateClick() {
      this.templateCreateForm = true;
      this.$store.commit("setTemplateFlag", true);
    },
    createTasksClick() {
      // console.log(this.selectedTemplate);
      this.$store
        .dispatch("getTemplateInfo", this.selectedTemplate.id)
        .then(() => {
          // let idSection = this.getAppsArray.find(
          //   (a) => a.name === this.templateInfo.nameSection
          // ).id;
          // this.$store.commit("setTemplateSectionId", idSection);
          // console.log(this.templateInfo);
          return this.$store.dispatch("getPacketableTasks");
        })
        .then(() => {
          this.$store.commit("setTasksFlag", true);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    copyTemplate() {
      this.$prompt(
        `${this.$t("templates.enterCopyTemplateNewName")} ${
          this.selectedTemplate.name
        }`,
        {
          confirmButtonText: this.$t("templates.accept"),
          cancelButtonText: this.$t("templates.cancellation"),
        }
      )
        .then(({ value }) => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("copyCronTemplate", {
            id: this.selectedTemplate.id,
            name: value,
          });
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    updTemplate() {
      this.$prompt(
        `${this.$t("templates.enterTemplateNewName")} ${
          this.selectedTemplate.name
        }`,
        {
          confirmButtonText: this.$t("templates.accept"),
          cancelButtonText: this.$t("templates.cancellation"),
          inputValue: this.selectedTemplate.name
        }
      )
        .then(({ value }) => {
          this.dataReloadingFlag = true;
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("updCronTemplateName", {
            id: this.selectedTemplate.id,
            name: value,
          });
        })
        .then(() => {
          this.dataReloadingFlag = false;
          this.markSelectedTemplate();
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    activateSchedule() {
      if (!this.selectedTemplate) return;
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("updateTemplateSchedule", {
          templateName: this.selectedTemplate.name,
          status: true,
        })
        .then((result) => {
          this.$store.commit("setLoading", false);
          if (!result.msg) return;
          this.schedulePacketsInfo = result.msg;
          this.showForm = true;
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("setLoading", false);
        });
    },
    forbidSchedule() {
      if (!this.selectedTemplate) return;
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("updateTemplateSchedule", {
          templateName: this.selectedTemplate.name,
          status: false,
        })
        .then((result) => {
          this.$store.commit("setLoading", false);
          if (!result.msg) return;
          this.schedulePacketsInfo = result.msg;
          this.showForm = true;
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    downloadClick() {
      let href =
        "data:application/octet-stream," +
        encodeURIComponent(this.schedulePacketsInfo);
      var link = document.createElement("a");
      link.setAttribute("href", href);
      link.setAttribute("download", "packets.txt");
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    deleteTemplate() {
      this.$confirm(
        `${this.$t("templates.thisActionDeleteThisTemplate")}: ${
          this.selectedTemplate.name
        }. ${this.$t("templates.continue")}?`,
        this.$t("templates.attention"),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("templates.cancellation"),
          type: "warning",
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch(
            "delCronTemplate",
            this.selectedTemplate.id
          );
        })
        .then(() => {
          this.$store.commit("setTemplate", null);
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    markSelectedTemplate() {
      // console.log(this.selectedTemplate);
      this.templateClassArray = [];
      if (!!this.selectedTemplate) {
        this.cronTemplates.forEach((template) => {
          if (template.id === this.selectedTemplate.id) {
            this.templateClassArray.push("selected");
          } else {
            this.templateClassArray.push("");
          }
        });
      } else {
        this.cronTemplates.forEach((template) =>
          this.templateClassArray.push("")
        );
      }
    },
  },
  computed: {
    ...mapGetters([
      "selectedTemplate",
      "cronTemplates",
      "templateInfo",
      "cronPackets",
      "getAppsArray",
    ]),
  },
  watch: {
    selectedTemplate() {
      this.markSelectedTemplate();
    },
    cronTemplates() {
      if (this.cronPackets && this.cronTemplates && !this.dataReloadingFlag) {
        this.markUnsavedJobs();
      }
    },
  },
  created() {
    if (this.cronPackets && this.cronTemplates) this.markUnsavedJobs();
    this.markSelectedTemplate();
  },
  components: {
    TemplateForm,
    TemplateTaskForm,
  },
  mixins: [markUnsavedMixin],
};
</script>

<style scoped src="./items.css">
</style>

<style scoped>
.main-content {
  height: calc(100vh - (198px + var(--header-height) + 5px));
}
.info-dialog {
  white-space: pre;
}
</style>